import pb from "../../lib/pocketbase";
import Logo from "../../components/icons/Logo";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { Status } from "../../lib/types";
import Button from "../../components/form/button";
import { _Classes } from "../../lib/styles";
import ErrorMessage from "../../components/form/errorMessage";
import { Helmet } from "react-helmet";
import { Input } from "../../components/ui/input";
import ModeSwitch from "../../components/ModeSwitch";
interface LoginData {
    email: string;
    password: string;
}

export default function Login() {
    const navigate = useNavigate();

    const [data, setData] = useState<LoginData>({
        email: "",
        password: ""
    });

    const [status, setStatus] = useState<Status>("none");
    const [error, setError] = useState<string>("");

    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    async function login() {
        setStatus("loading");

        if (!data.email || !emailRegex.test(data.email)) {
            setStatus("error");
            setError("Email is not valid.");
            setTimeout(() => {
                setStatus("none");
            }, 2000);

            return;
        }
        if (!data.password) {
            setStatus("error");
            setError("Password is not valid.");
            setTimeout(() => {
                setStatus("none");
            }, 2000);

            return;
        }

        pb.collection("users")
            .authWithPassword(data.email, data.password)
            .then(() => {
                setStatus("success");
                setTimeout(() => {
                    navigate("/studio");
                }, 200);
            })
            .catch((error: Error) => {
                setError(error.message);
                setStatus("error");
            })
            .finally(() => {
                setTimeout(() => {
                    setStatus("none");
                }, 2000);
            });
    }

    return (
        <div className="flex min-h-[100dvh] w-full flex-col items-center justify-center gap-2">
            <div className="absolute right-4 top-4">
                <ModeSwitch />
            </div>
            <Helmet>
                <title>ReinVB Studio — Login</title>
            </Helmet>
            <div className="flex w-full max-w-sm items-start">
                <Link to="/">
                    <Button variant={"ghost"} size={"ghost"} className="text-sm text-slate-400 dark:text-slate-700">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-4 w-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75" />
                        </svg>
                        Back
                    </Button>
                </Link>
            </div>
            <div className="mb-8 flex w-full items-center justify-center gap-4">
                <Logo /> <span className="text-2xl font-bold">Studio.</span>
            </div>
            <div className="w-full max-w-sm">
                <ErrorMessage error={error} close={() => setError("")} />
            </div>
            <div className="flex w-full max-w-sm flex-col gap-3">
                <Input onKeyDown={(e) => e.key === "Enter" && login()} value={data.email} onChange={(e) => setData({ ...data, email: e.target.value })} type="text" placeholder="E-mailadres" />
                <Input onKeyDown={(e) => e.key === "Enter" && login()} value={data.password} onChange={(e) => setData({ ...data, password: e.target.value })} type="password" placeholder="Password" />
                <Button onClick={login} status={status} variant="dark" type="submit">
                    {status === "loading" && "Logging in"}
                    {status === "success" && "Logged in"}
                    {status === "error" && "Error"}
                    {status === "none" && "Login"}
                </Button>
                <p className="text-sm text-slate-500 dark:text-slate-600">
                    No account?{" "}
                    <Link to="/studio/registrate" className="font-bold text-slate-600 dark:text-slate-500">
                        Create account
                    </Link>
                </p>
            </div>
        </div>
    );
}
